'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PNFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-gzhlysesx", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-nqdv721uq", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-cavhzdz9z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-o297q6ast", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-kati3c7v6" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-wwd5if72w", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-9t1x64jip" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-cavhzdz9z", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { id: "mantine-kati3c7v6", d: "M0 0h18v14H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        id: "mantine-9t1x64jip",
        d: "M.145.15h5.184v3.168c-.282 1.726-1.175 3.014-2.68 3.864C1.19 6.32.356 5.032.145 3.318z"
      }
    )), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-gzhlysesx)" }, /* @__PURE__ */ React.createElement("use", { fill: "#2e42a5", xlinkHref: "#mantine-cavhzdz9z" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-nqdv721uq)" }, /* @__PURE__ */ React.createElement("use", { fill: "#2b409a", xlinkHref: "#mantine-kati3c7v6" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-o297q6ast)" }, /* @__PURE__ */ React.createElement("g", { fillRule: "nonzero" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M-2.004 13l3.96 1.737L18.09 1.889l2.09-2.582-4.236-.58-6.58 5.536-5.297 3.73z"
      }
    ), /* @__PURE__ */ React.createElement("path", { fill: "#f50100", d: "M-1.462 14.217l2.018 1.008L19.429-.933h-2.833z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M20.004 13l-3.96 1.737L-.09 1.889-2.18-.693l4.236-.58 6.58 5.536 5.297 3.73z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f50100",
        d: "M19.87 13.873l-2.019 1.008-8.036-6.917-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.926z"
      }
    )), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f50100",
        stroke: "#f7fcff",
        strokeWidth: "1.5",
        d: "M10.735-.75v6h8.015v3.5h-8.016v6h-3.5v-6H-.75v-3.5h7.984v-6z"
      }
    ))), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-nqdv721uq)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#5eaa22",
        d: "M20.616 10.757c.066.73.027 1.301-.118 1.715-.216.62-.326.98-.326.584 0-.397-.152-.711-.274-.711-.123 0-.026.393-.15.393-.122 0-.545.068-.545-.163 0-.23-.056.618.219.694s-.134.312-.316.239c.5.162.847.313 1.043.45.588.734 1.156 1.056 1.705.967-.748-.259-1.056-.634-.924-1.128.198-.74.924-.847.924-.847.228.076.338.214.331.413-.01.299.25-.094.25-.094.027-.251.026-.408-.005-.47-.046-.091.781-.27.834-.658-.564.026-.865.005-.904-.061-.058-.1.262-.257.162-.451-.067-.13-.597.24-1.592 1.11.344-.593.515-1.047.515-1.365 0-.477-.13-.803-.515-.803-.256 0-.36.062-.314.186zm8.454.141c.21.182.157.36-.157.537.147.142.304.214.472.214s.272-.072.313-.214c.013.317.293.535.84.655.196-.28.196-.497 0-.65.232-.049.339-.166.322-.353a.425.425 0 01-.488-.126c-.203-.222-.598-.325-.886-.274a1.566 1.566 0 00-.282-.075.164.164 0 00-.133.286z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#96877d",
        d: "M23.404 13.415c.566 1.065.672 1.708.318 1.928-.53.331 2.524.096 2.812 0 .287-.095-.058-.599-.378-.739-.319-.14-1.63-.605-1.98-.956-.35-.35-.136-.475.145-.821.281-.347 1.322-.485 1.322-.809s.66-1.658 1.122-1.76c.461-.1.212-.259.106-.259s-.744.658-.986.54-.271-.11 0-.398.476-.616.117-.379-.95.613-1.235.613c-.284 0-1.296-.128-1.17.163.125.292.178.797.724 1.139.546.341.309.591-.145.92-.303.22-.56.492-.772.818z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#ffd018",
        fillRule: "nonzero",
        d: "M29.039 11.303l-1.619 3.245c-.031.611.339.713 1.11.306 1.157-.611 1.111-1.044 1.445-1.044s.44-.185.44-.185l-.223-.175c-.017-.213.022-.343.115-.39-.184-.102-.289-.11-.315-.026-.04.127-.234-.265-.124-.265-.162.263-.26.445-.295.548-.235-.096-.347-.365-.335-.807s-.055-.845-.2-1.207zm-7.703-.514s-.824.192-.735.391.22-.005-.183.235c-.473.366-.76.529-.864.489-.154-.06.11.138.11-.489 0-.626-.412-.116 0-.534.411-.419.556-.092.754-.333.198-.24.02-.113.556-.113s.362.354.362.354zm2.514 3.225c-1.537 1.209-2.46 1.858-2.768 1.948-.46.136.949-.037 1.293-.276.23-.16.722-.717 1.476-1.672z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#5eaa22",
        d: "M28.425 17.195c.147.952.028 1.381-.357 1.287a17.436 17.436 0 01-.818-.213c.141.444.313.665.515.665.344.671.45 1.112.318 1.324.592-.48.84-.912.745-1.295-.144-.573.23.095.23.095.218.105.406.099.564-.019.236-.176-.003-.098-.24-.434-.236-.336-.178-1.28-.898-1.768-.48-.326-.775-.484-.887-.474-.353-.577-.424-.847-.212-.809 1.517.52 2.295.847 2.334.98.06.2.663.163.361-.408-.302-.572-1.928-.916-2.122-1.077-.193-.162-.013-.773-.36-.906-.348-.133-1.298-1.078-1.297-1.534 0-.455-.446-.67-.835-.67s-1.12-.112-1.43-.112c-.308 0-.596.517-.298.517.299 0 .044.968-.456 1.18s-.887.515-1.457.515.808.493 1.028.298.147-.484.885-.813c.738-.33 1.443-.525 1.354-.263-.09.263.138.701.486.543.348-.16.46-.56.46-.28s.532 1.717.94 2.278c.271.374.754.838 1.447 1.393z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#ffd018",
        fillRule: "nonzero",
        d: "M23.571 11.946c-.18.287-.18.43 0 .43.27 0 .706 0 .44-.215-.176-.144-.323-.215-.44-.215zm.904-.011c0 .191.064.287.189.287.187 0 .354.286.354 0 0-.287.26-.192-.141-.287-.268-.063-.402-.063-.402 0zM25.63 12c-.12.091-.151.218-.09.38.09.242.294.723 0 .723-.296 0-.538.173-.308.173.23 0 .64.173.64 0s.167.285.167 0v-.59c0-.167.166-.215 0-.45-.111-.157-.248-.235-.41-.235zm.417 1.672c.251.79.445 1.236.582 1.338.204.153.296 1.44.386 1.58.09.14 1.315.847 1.315 1.226s.377-.292.188-.667c-.188-.375-.782-1.175-1.209-1.349-.427-.174-.373-.596-.462-.893-.09-.297.53.24 0-.433-.532-.673-.518-.312-.368-.312s.3-.08.15-.184c-.1-.07-.294-.172-.582-.306zm-3.993 2.444c-.816 1.44-1.296 2.198-1.442 2.273-.218.111-.38.134-.492 0-.112-.135-.123.36 0 .496.123.135.492.135.697-.106.022.406.14.761.352 1.067.32.458.453.331.453.59s.076.603.173.603.173.815 0 .815.401.067.651-.137c.25-.204.358-.36.304-.36s-.696-.337-.696-.577c0-.239-.432-.426-.432-.781s-.224-.778-.224-.946c0-.168.192.065.397-.095.137-.106.223-.296.26-.57-.217.145-.36.182-.433.11-.108-.11-.449-.324-.224-.692.15-.245.368-.808.656-1.69z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#5eaa22",
        d: "M24.174 9.302c-.292.13-.39.292-.292.485.146.29.199.417.292.353.094-.064.75-.185.603-.511s-.455-.327-.455-.327h-.148z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#ffd018",
        fillRule: "nonzero",
        d: "M25.694 9.146c-.386-.171-.514-.171-.386 0 .193.256.44.39.617.39s.547-.052.362-.156a3.512 3.512 0 00-.593-.234z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#5eaa22",
        d: "M19.626 16.616c.122.265.244.444.366.536.074.406.188.664.342.774.206-.01.314-.174.324-.49.35-.102.577-.044.68.174-.068.025-.102.13-.102.316s.08.38.238.58c.073-.64.272-1.167.598-1.58.326-.414.536-.661.63-.743v-.697c-.676.55-1.085 1.053-1.228 1.51-.34.012-.579-.012-.717-.07-.207-.088.259-.232 0-.544-.258-.312-.14.44-.423.234a.509.509 0 01-.311-.214.226.226 0 00-.397.214z"
      }
    ), /* @__PURE__ */ React.createElement("g", { transform: "translate(22.042 15.044)" }, /* @__PURE__ */ React.createElement("use", { fill: "#5eaa22", xlinkHref: "#mantine-9t1x64jip" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-wwd5if72w)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#58a5ff",
        d: "M2.61-.02L.343 4.68l3.072-2.79L5.53 5.396V-.02L3.416 1.713z"
      }
    ), /* @__PURE__ */ React.createElement("g", { fill: "#ffd018" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M2.707 3.2a.17.17 0 01.169.17v3.018a.169.169 0 11-.338 0V3.37a.17.17 0 01.169-.17z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M1.784 3.948c0-.092.075-.166.166-.166h1.527a.166.166 0 110 .332H1.95a.166.166 0 01-.166-.166zm.99 2.497l-.131.106c-.193-.234-.369-.347-.524-.347-.229 0-.415-.19-.567-.553l.156-.064c.129.306.268.45.41.45.217 0 .434.138.656.408z"
      }
    ), /* @__PURE__ */ React.createElement("path", { d: "M1.398 5.076v.816a.002.002 0 00.003.002l.613-.253a.002.002 0 000-.002l-.613-.564a.002.002 0 00-.003.001z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M2.635 6.445l.13.106c.193-.234.37-.347.525-.347.228 0 .414-.19.566-.553L3.7 5.587c-.128.306-.268.45-.41.45-.216 0-.434.138-.655.408z"
      }
    ), /* @__PURE__ */ React.createElement("path", { d: "M4.01 5.076v.816a.002.002 0 01-.002.002l-.614-.253a.002.002 0 010-.002l.613-.564a.002.002 0 01.003.001z" })), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M2.366 2.015h1v1.007h-1z" }))))))
  );
}

export { PNFlag };
//# sourceMappingURL=PN.mjs.map
